export default "__VITE_ASSET__MxJS9SBA__"